import { render, staticRenderFns } from "./BulkCategory.vue?vue&type=template&id=78d4dd58&scoped=true&"
import script from "./BulkCategory.vue?vue&type=script&lang=ts&"
export * from "./BulkCategory.vue?vue&type=script&lang=ts&"
import style0 from "./BulkCategory.vue?vue&type=style&index=0&id=78d4dd58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d4dd58",
  null
  
)

export default component.exports